export const isApplicationLoading = (store) => !store.global.isInitialized;
